export default class ProjectLinks {
  public static readonly LINK_REGISTRATION: string = '/sign-up';
  public static readonly LINK_ACCEPT_ADMIN_SIGNUP_INVITATION: string = '/accept-admin-signup-invitation';
  public static readonly LINK_CHANGE_PASSWORD: string = '/change-password';
  public static readonly LINK_SECOND_AUTH_LEVEL: string = '/second-auth-level';
  public static readonly LINK_LOGIN: string = '/login';
  public static readonly BIND_AUTHENTICATOR: string = '/bind-authenticator';
  public static readonly LINK_CONTACT_US: string = '/contact-us';
  public static readonly LINK_DONATE: string = '/donate';
  public static readonly LINK_TERMS: string = '/terms';
  public static readonly LINK_ABOUT_US: string = '/about-us';
  public static readonly LINK_CHAT: string = '/chat';
  public static readonly LINK_SEARCH: string = '/search';
  public static readonly LINK_MAP: string = '/map';
  public static readonly LINK_DEFAULT: string = '/';

  public static readonly LINK_PROFILE: string = '/profile';
  public static readonly LINK_PROFILE_EDIT: string = '/profile/edit';
  public static readonly LINK_PROFILE_VIEW: string = '/profile/view';

  public static readonly LINK_PROJECTS: string = '/projects';
  public static readonly LINK_PROJECTS_VIEW: string = '/projects/view';
  public static readonly LINK_PROJECTS_ALL: string = '/projects/all';
  public static readonly LINK_PROJECTS_CREATE: string = '/projects/create';
  public static readonly LINK_PROJECTS_MANAGE: string = '/projects/manage';
  public static readonly LINK_PROJECTS_INVITE: string = '/invite-to-project';

  public static readonly LINK_COMMUNITY: string = '/community';
  public static readonly LINK_COMMUNITY_VIEW: string = '/community/view';
  public static readonly LINK_COMMUNITY_ALL: string = '/community/all';
  public static readonly LINK_COMMUNITY_CREATE: string = '/community/create';

  public static readonly LINK_CHARITY_VIEW: string = '/charity/view';
  public static readonly LINK_CHARITY_CREATE: string = '/charity/create';
  public static readonly LINK_CHARITY_MANAGE: string = '/charity/manage';

  public static readonly LINK_COMMUNITY_MANAGE: string = '/community/manage';
  public static readonly LINK_COMMUNITY_INVITE: string = '/invite-to-community';
  public static readonly LINK_CHARITY_INVITE: string = '/invite-to-charity';

  public static readonly LINK_POSTS: string = '/posts';
  public static readonly LINK_POSTS_VIEW: string = '/posts/view';
  public static readonly LINK_POSTS_UPDATE: string = '/posts/update';
  public static readonly LINK_POSTS_CREATE: string = '/posts/create';
  public static readonly LINK_POSTS_ALL: string = '/posts/all';

  public static readonly LINK_FILES: string = 'files';
  public static readonly LINK_FILES_MANAGER: string = '/files/manager';
  public static readonly LINK_FILES_DETAILS: string = '/files/details';

  public static readonly LINK_CONNECTIONS: string = 'connections';
  public static readonly LINK_CONNECTIONS_GROUP_MESSAGE: string = '/connections/list/group-message';
  public static readonly LINK_CONNECTIONS_LIST: string = '/connections/list';
  public static readonly LINK_GROUP_MESSAGE: string = 'list/group-message';

  public static readonly LINK_MEDICAL: string = '/medical';
  public static readonly LINK_DOCTOR: string = 'doctor-links';
  public static readonly LINK_PATIENT: string = 'patient-links';

  public static readonly LINK_ADMINS: string = '/admins';
  public static readonly LINK_DEACTIVATED_USERS: string = '/deactivated-users';

  public static readonly LINK_BLOCKED_USERS: string = '/blocked-users';
  public static readonly LINK_CATEGORIES: string = 'categories/diseases';
  public static readonly LINK_CHARITY_FOCUSES: string = 'charity-focus';

  public static readonly LINK_PREFERENCES: string = '/preferences';
}
